import client from '../../client';
import {
  GET_TIMINGS_DATA,
  GET_TIMINGS_DATA_SUCCESS,
  GET_TIMINGS_DATA_FAIL
} from '../constants/timings';

export const getTimingData = (params, graphId) => dispatch => {
  dispatch({
    type: GET_TIMINGS_DATA,
    graphId
  });

  client
    .get('/timings', { params })
    .then(({data}) => {
      dispatch({
        type: GET_TIMINGS_DATA_SUCCESS,
        data,
        graphId
      });
    })
    .catch(error => {
      dispatch({
        type: GET_TIMINGS_DATA_FAIL,
        error,
        graphId
      })
    })
}



// WEBPACK FOOTER //
// ./src/redux/actions/timings.js